<template>
    <div>
        <div class="repositories_and_chart">
            <span class="unionIcon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo_chart_title"><span class="repoText">Repositories</span> 
            <span class="d_line">/ </span>Charts</span>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            
        },

        methods: {
        }
    }
</script>
